/**
 * Shared style constants used across the Excel writers. Keeping them in
 * one file means we can tweak the whole look (colors, borders, fills) in
 * a single place to match a new design system.
 *
 * All colors use the ExcelJS ARGB format (`'FFRRGGBB'`).
 */

export const COLORS = {
  headerFill: 'FF1E40AF', // primary-700
  headerBorder: 'FF1E3A8A', // primary-800
  headerFont: 'FFFFFFFF',

  bandedRowFill: 'FFF8FAFC', // slate-50
  rowBorder: 'FFE2E8F0', // slate-200

  groupLevel0Fill: 'FFDBEAFE', // blue-100
  groupLevel1Fill: 'FFE0E7FF', // indigo-100
  groupLevel2Fill: 'FFF3F4F6', // neutral-100
  groupBorder: 'FF94A3B8', // slate-400

  subtotalFill: 'FFF1F5F9', // slate-100
  grandTotalFill: 'FFE2E8F0', // slate-200
  subtotalBorder: 'FF94A3B8',
  grandTotalBorder: 'FF475569', // slate-600

  slotFill: 'FF61D295', // success-500 — vert franc pour les creneaux "présent" (matrices US-C) — plus visible qu'un bleu clair, aligné avec `bg-success-500` à l'écran
  slotAbsentFill: 'FFF87171', // danger-400 — rouge doux pour les creneaux "absent" (matrices US-C), aligné avec `bg-danger-500` à l'écran
} as const;

/** Excel SUBTOTAL function codes — used to emit live-recalculating totals. */
export const SUBTOTAL_FUNCTION_CODE: Record<string, number | null> = {
  sum: 9,
  avg: 1,
  count: 3,
  // `custom` has no equivalent — caller falls back to pre-computed values.
  custom: null,
};

/** Pick the fill color for a group header based on its depth in the tree. */
export function fillForGroupLevel(level: number): string {
  if (level === 0) return COLORS.groupLevel0Fill;
  if (level === 1) return COLORS.groupLevel1Fill;
  return COLORS.groupLevel2Fill;
}
